import styled from 'styled-components';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import withUsageTracking from '../hoc/withUsageTracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledFormattedMessage = styled(FormattedMessage).withConfig({
  displayName: "EPSettingsButton__StyledFormattedMessage",
  componentId: "gyzox2-0"
})(["font-weight:400;margin-left:0.25em !important;"]);
const EPSettingsButton = ({
  onClick,
  onTrackUsage,
  hideLabel
}) => {
  const showLabel = !hideLabel;
  function handleClick() {
    onClick();
    onTrackUsage('settings button click');
  }
  return /*#__PURE__*/_jsxs(UIButton, {
    "data-test-id": "ep-settings-button",
    className: "p-all-2",
    use: "tertiary-light",
    size: "medium",
    onClick: handleClick,
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "settings",
      size: 16
    }), showLabel && /*#__PURE__*/_jsx(StyledFormattedMessage, {
      message: "epSettingsButton.label"
    })]
  });
};
export { EPSettingsButton };
export default withUsageTracking(EPSettingsButton);